import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import "./PainterServiceSections.css";

const PainterFaq = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="pnt-faq">
      <div className="pnt-container pnt-faq-grid">
        <div className="pnt-faq-head">
          <span className="pnt-tag">Questions &amp; Answers</span>
          <h2 className="pnt-heading">{data.title}</h2>
          <p className="pnt-subheading pnt-subheading-left">{data.titleDesc}</p>
        </div>

        <div className="pnt-faq-list">
          {data.main.map((faq, index) => (
            <div className={`pnt-faq-item ${activeIndex === index ? "pnt-faq-open" : ""}`} key={index}>
              <button
                className="pnt-faq-question"
                onClick={() => toggleFaq(index)}
                aria-expanded={activeIndex === index}
                aria-controls={`pnt-faq-answer-${index}`}
              >
                <span>{faq.question}</span>
                <span className="pnt-faq-toggle">
                  {activeIndex === index ? <RemoveIcon fontSize="small" /> : <AddIcon fontSize="small" />}
                </span>
              </button>
              <div className="pnt-faq-answer" id={`pnt-faq-answer-${index}`}>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PainterFaq;
